import styled from "styled-components";
import { FaFacebookF, FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import { FiClock } from "react-icons/fi";
import { BsCreditCard2Front } from "react-icons/bs";
import { Link } from "react-router-dom";
import logoQuali from "../assets/logoDQT.jpg";
import belfortTourisme from "../assets/Belfort_tourisme.jpg";

const horaires = [
  { jour: "Lundi",    midi: "12:00–13:30", soir: "Fermé" },
  { jour: "Mardi",    midi: "12:00–13:30", soir: "19:00–21:15" },
  { jour: "Mercredi", midi: "Fermé",        soir: "Fermé" },
  { jour: "Jeudi",    midi: "12:00–13:30", soir: "19:00–21:15" },
  { jour: "Vendredi", midi: "12:00–13:30", soir: "19:00–21:15" },
  { jour: "Samedi",   midi: "12:00–13:30", soir: "19:00–21:15" },
  { jour: "Dimanche", midi: "12:00–13:30", soir: "19:00–21:15" },
];

const paiements = ["Espèces", "Chèque", "Carte bleue", "Ticket restaurant", "ANCV"];

export default function Footer() {
  return (
    <FooterWrap id="footer">
      <TopBorder />

      <FooterGrid>
        {/* ─ Col 1 : Identité ─ */}
        <FooterCol>
          <FooterBrand>La Petite Charrue</FooterBrand>
          <FooterSub>Auberge du Terroir</FooterSub>

          <Divider />

          <SocialRow>
            <SocialLink
              href="https://fr-fr.facebook.com/lapetitecharrue90/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <FaFacebookF />
            </SocialLink>
          </SocialRow>

          <BadgeRow>
            <Badge src={logoQuali}        alt="Qualité Tourisme" />
            <Badge src={belfortTourisme}  alt="Belfort Tourisme" />
          </BadgeRow>
        </FooterCol>

        {/* ─ Col 2 : Infos légales ─ */}
        <FooterCol>
          <ColTitle><FaMapMarkerAlt /> Adresse</ColTitle>
          <InfoBlock>
            <p>La Petite Charrue</p>
            <p>13 rue Principale</p>
            <p>90150 Vauthiermont</p>
          </InfoBlock>
          <InfoBlock>
            <p>Siret&nbsp;: 45295260900017</p>
            <p>RCS&nbsp;: Belfort B 452 952 609</p>
          </InfoBlock>
          <MentionsLink to="/Mentions">Mentions légales</MentionsLink>
        </FooterCol>

        {/* ─ Col 3 : Horaires ─ */}
        <FooterCol>
          <ColTitle><FiClock /> Horaires de service</ColTitle>
          <HoraireTable>
            {horaires.map(({ jour, midi, soir }) => (
              <HoraireRow key={jour}>
                <HoraireJour>{jour}</HoraireJour>
                <HoraireSlots>
                  <span>{midi}</span>
                  {soir !== "Fermé" && <span>{soir}</span>}
                  {soir === "Fermé" && midi === "Fermé" && <Ferme>Fermé</Ferme>}
                  {soir === "Fermé" && midi !== "Fermé" && <Ferme>soir fermé</Ferme>}
                </HoraireSlots>
              </HoraireRow>
            ))}
          </HoraireTable>
        </FooterCol>

        {/* ─ Col 4 : Contact + Paiement ─ */}
        <FooterCol>
          <ColTitle><FaPhone /> Contact</ColTitle>
          <ContactBlock>
            <ContactLink href="tel:0384238914">
              <FaPhone /> 03 84 23 89 14
            </ContactLink>
            <ContactLink href="mailto:aubergelapetitecharrue@gmail.com">
              <FaEnvelope /> aubergelapetitecharrue<wbr />@gmail.com
            </ContactLink>
          </ContactBlock>

          <ColTitle style={{ marginTop: "1.75rem" }}>
            <BsCreditCard2Front /> Moyens de paiement
          </ColTitle>
          <PaiementList>
            {paiements.map((p) => (
              <PaiementItem key={p}>{p}</PaiementItem>
            ))}
          </PaiementList>
        </FooterCol>
      </FooterGrid>

      <LowerFooter>
        <LowerText>
          &copy; {new Date().getFullYear()} La Petite Charrue — Tous droits réservés
        </LowerText>
        <LowerCredit>
          Conception&nbsp;: <GoldSpan>Heidet Antoine</GoldSpan>
        </LowerCredit>
      </LowerFooter>
    </FooterWrap>
  );
}

/* ─── Styled Components ─── */

const FooterWrap = styled.footer`
  background: var(--bg-surface);
  margin: 0 !important;
  padding: 0 !important;
`;

const TopBorder = styled.div`
  width: 100%;
  height: 3px;
  background: linear-gradient(to right, transparent, var(--primary), var(--secondary), var(--primary), transparent);
`;

const FooterGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 3rem 2.5rem;
  padding: 4rem 6vw;

  @media (max-width: 1100px) { grid-template-columns: repeat(2, 1fr); }
  @media (max-width: 600px)  { grid-template-columns: 1fr; gap: 2.5rem; padding: 2.5rem 1.25rem; }
`;

const FooterCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const FooterBrand = styled.h3`
  font-family: var(--font-heading);
  font-style: italic;
  font-size: 1.5rem;
  color: var(--primary);
  line-height: 1;
`;

const FooterSub = styled.span`
  font-family: var(--font-script);
  font-size: 0.9rem;
  color: var(--cream-muted);
  letter-spacing: 0.12em;
`;

const Divider = styled.div`
  width: 40px;
  height: 1px;
  background: var(--border);
  margin: 0.75rem 0;
`;

const SocialRow = styled.div`
  display: flex;
  gap: 0.75rem;
  margin-bottom: 1rem;
`;

const SocialLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 50%;
  color: var(--primary);
  font-size: 0.95rem;
  transition: var(--transition);

  &:hover {
    background: var(--primary);
    color: var(--bg-base);
    transform: translateY(-2px);
    box-shadow: 0 4px 14px rgba(200, 151, 62, 0.3);
  }
`;

const BadgeRow = styled.div`
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
  margin-top: 0.5rem;
`;

const Badge = styled.img`
  height: 52px;
  width: auto;
  object-fit: contain;
  border-radius: 4px;
  opacity: 0.85;
  filter: grayscale(20%);
  transition: var(--transition);

  &:hover { opacity: 1; filter: none; }
`;

const ColTitle = styled.h4`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-family: var(--font-body);
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  color: var(--primary);
  margin-bottom: 0.5rem;
  margin-top: 0.25rem;

  svg { font-size: 0.85rem; }
`;

const InfoBlock = styled.div`
  p {
    font-size: 0.88rem;
    color: var(--cream-dim);
    line-height: 1.7;
  }
  margin-bottom: 0.75rem;
`;

const MentionsLink = styled(Link)`
  font-size: 0.8rem;
  color: var(--cream-muted);
  text-decoration: none;
  border-bottom: 1px dashed var(--border);
  width: fit-content;
  margin-top: 0.5rem;
  transition: color 0.2s;

  &:hover { color: var(--primary); }
`;

const HoraireTable = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`;

const HoraireRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 0.75rem;
  font-size: 0.82rem;
  padding: 0.3rem 0;
  border-bottom: 1px solid var(--border-light);

  &:last-child { border-bottom: none; }
`;

const HoraireJour = styled.span`
  color: var(--cream-dim);
  font-weight: 700;
  min-width: 75px;
  flex-shrink: 0;
`;

const HoraireSlots = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.15rem;
  color: var(--cream-muted);
  font-size: 0.78rem;
  text-align: right;
`;

const Ferme = styled.span`
  color: var(--secondary-light);
  font-style: italic;
`;

const ContactBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
`;

const ContactLink = styled.a`
  display: flex;
  align-items: center;
  gap: 0.55rem;
  font-size: 0.85rem;
  color: var(--cream-dim);
  text-decoration: none;
  transition: color 0.2s;
  word-break: break-word;

  svg { color: var(--primary); flex-shrink: 0; }
  &:hover { color: var(--primary); }
`;

const PaiementList = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
`;

const PaiementItem = styled.li`
  font-size: 0.85rem;
  color: var(--cream-muted);
  display: flex;
  align-items: center;
  gap: 0.4rem;

  &::before {
    content: "";
    display: inline-block;
    width: 4px;
    height: 4px;
    background: var(--primary);
    border-radius: 50%;
    flex-shrink: 0;
  }
`;

const LowerFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.1rem 6vw;
  border-top: 1px solid var(--border-light);
  background: rgba(0, 0, 0, 0.3);
  flex-wrap: wrap;
  gap: 0.5rem;

  @media (max-width: 600px) {
    flex-direction: column;
    text-align: center;
    padding: 1rem 1.25rem;
  }
`;

const LowerText = styled.p`
  font-size: 0.78rem;
  color: var(--cream-muted);
  letter-spacing: 0.04em;
`;

const LowerCredit = styled.p`
  font-size: 0.78rem;
  color: var(--cream-muted);
`;

const GoldSpan = styled.span`
  color: var(--primary);
  font-weight: 700;
`;
